<template>
  <div class="ticket">
    <div class="list-group list-group-flush">
      <div class="card-header">
        #{{ ticket.iid }} - {{ ticket.title }}
      </div>
      <div class="list-group-item">
        <p><strong>Submitted: </strong> {{ ticket.created_at | date_format }}</p>
        <template v-if="ticket.labels.length > 1">
          <p>
            <span v-for="(label, index) in ticket.labels" class="badge" :key="index"
            :class="{
              'badge-danger': label === 'High Priority',
              'badge-primary': label === 'In Development'
            }">{{ label }}</span>
          </p>
        </template>
        <template v-if="ticket.state === 'closed'">
          <p>
            <span class="badge badge-success">
              <span class="fa fa-check-square"></span>
              &nbsp;Completed
            </span>
          </p>
        </template>
        <p v-html="nl2br(ticket.description)"></p>
      </div>
      <div class="card-footer text-right">
        <router-link :to="{ path: '/tickets/' + ticket.iid }" class="btn btn-sm btn-primary">
          <span class="fa fa-search"></span>
          View
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { nl2br } from '@/util/filters'

export default {
  name: 'Ticket',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    ticket () {
      return {
        ...this.object,
        labels: this.object.labels.filter(function (label) {
          return label !== 'admin-issue' && label !== 'not-a-bug'
        })
      }
    }
  },
  methods: {
    nl2br (message) {
      return nl2br(message).replace('<img', '<img style="max-height:100px;"')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/Ticket.vue